module.exports = __webpack_public_path__ + "static/img/icon_tj_pdfbj.a47b5a22.svg";